import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CookiePolicy = () => {
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);
    return (
        <>
            <div className="min-h-screen  from-zinc-900 via-zinc-900  pt-16">
                <main className="max-w-4xl mx-auto px-4 pt-16">
                    <h1 className="text-3xl font-bold text-zinc-100 mb-8">
                        {t("cookiePolicy.title")}
                    </h1>
                    <p className="text-zinc-400 mb-8">
                        {t("cookiePolicy.effectiveDate")}: {new Date().toLocaleDateString()}
                    </p>

                    <div className="prose prose-invert">
                        <p className="text-zinc-300">
                            {t("cookiePolicy.intro")}
                            <Link
                                to="/"
                                className="text-amber-500 hover:text-amber-400 transition-colors"
                            >
                                bidcoin.live
                            </Link>
                            {t("cookiePolicy.introContinuation")}
                        </p>

                        {/* What Are Cookies? */}
                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-amber-500 mb-4">
                                {t("cookiePolicy.whatAreCookies")}
                            </h2>
                            <p className="text-zinc-300">
                                {t("cookiePolicy.whatAreCookiesDescription")}
                            </p>
                        </section>

                        {/* Types of Cookies */}
                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-amber-500 mb-4">
                                {t("cookiePolicy.typesOfCookies")}
                            </h2>
                            <div className="space-y-4">
                                {/* Essential Cookies */}
                                <div>
                                    <h3 className="text-lg font-medium text-zinc-100">
                                        {t("cookiePolicy.essentialCookies")}
                                    </h3>
                                    <p className="text-zinc-300">
                                        {t("cookiePolicy.essentialCookiesDescription")}
                                    </p>
                                    <p className="text-zinc-300 mt-2">
                                        {t("cookiePolicy.examples")}
                                    </p>
                                    <ul className="list-disc pl-6 text-zinc-300">
                                        <li>{t("cookiePolicy.sessionManagement")}</li>
                                    </ul>
                                </div>

                                {/* Functional Cookies */}
                                <div>
                                    <h3 className="text-lg font-medium text-zinc-100">
                                        {t("cookiePolicy.functionalCookies")}
                                    </h3>
                                    <p className="text-zinc-300">
                                        {t("cookiePolicy.functionalCookiesDescription")}
                                    </p>
                                    <p className="text-zinc-300 mt-2">
                                        {t("cookiePolicy.examples")}
                                    </p>
                                    <ul className="list-disc pl-6 text-zinc-300">
                                        <li>{t("cookiePolicy.languagePreferences")}</li>
                                        <li>{t("cookiePolicy.uiSettings")}</li>
                                    </ul>
                                </div>

                                {/* Analytics Cookies */}
                                <div>
                                    <h3 className="text-lg font-medium text-zinc-100">
                                        {t("cookiePolicy.analyticsCookies")}
                                    </h3>
                                    <p className="text-zinc-300">
                                        {t("cookiePolicy.analyticsCookiesDescription")}
                                    </p>
                                    <p className="text-zinc-300 mt-2">
                                        {t("cookiePolicy.examples")}
                                    </p>
                                    <ul className="list-disc pl-6 text-zinc-300">
                                        <li>{t("cookiePolicy.googleAnalytics")}</li>
                                    </ul>
                                </div>

                                {/* Performance Cookies */}
                                <div>
                                    <h3 className="text-lg font-medium text-zinc-100">
                                        {t("cookiePolicy.performanceCookies")}
                                    </h3>
                                    <p className="text-zinc-300">
                                        {t("cookiePolicy.performanceCookiesDescription")}
                                    </p>
                                </div>
                            </div>
                        </section>

                        {/* Third-Party Cookies */}
                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-amber-500 mb-4">
                                {t("cookiePolicy.thirdPartyCookies")}
                            </h2>
                            <p className="text-zinc-300">
                                {t("cookiePolicy.thirdPartyCookiesDescription")}
                            </p>
                            <p className="text-zinc-300 mt-4">
                                {t("cookiePolicy.thirdPartyServices")}
                            </p>
                            <ul className="list-disc pl-6 text-zinc-300">
                                <li>{t("cookiePolicy.googleAnalytics")}</li>
                                <li>{t("cookiePolicy.socialMediaPlatforms")}</li>
                            </ul>
                            <p className="text-zinc-300 mt-4">
                                {t("cookiePolicy.thirdPartyControl")}
                            </p>
                        </section>

                        {/* How We Use Cookies */}
                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-amber-500 mb-4">
                                {t("cookiePolicy.howWeUseCookies")}
                            </h2>
                            <p className="text-zinc-300">{t("cookiePolicy.useOfCookies")}</p>
                            <ul className="list-disc pl-6 text-zinc-300">
                                <li>{t("cookiePolicy.ensureFunctionality")}</li>
                                <li>{t("cookiePolicy.rememberPreferences")}</li>
                                <li>{t("cookiePolicy.monitorPerformance")}</li>
                                <li>{t("cookiePolicy.analyzeBehavior")}</li>
                            </ul>
                        </section>

                        {/* Managing Cookies */}
                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-amber-500 mb-4">
                                {t("cookiePolicy.managingCookies")}
                            </h2>
                            <p className="text-zinc-300">
                                {t("cookiePolicy.manageCookiesDescription")}
                            </p>
                            <p className="text-zinc-300 mt-4">
                                {t("cookiePolicy.toManageCookies")}
                            </p>
                            <ul className="list-disc pl-6 text-zinc-300">
                                <li>{t("cookiePolicy.browserHelp")}</li>
                                <li>{t("cookiePolicy.optOutTools")}</li>
                            </ul>
                        </section>

                        {/* Updates to Policy */}
                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-amber-500 mb-4">
                                {t("cookiePolicy.updatesToPolicy")}
                            </h2>
                            <p className="text-zinc-300">{t("cookiePolicy.updatesDescription")}</p>
                        </section>

                        {/* Contact Information */}
                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-amber-500 mb-4">
                                {t("cookiePolicy.contactUs")}
                            </h2>
                            <p className="text-zinc-300">{t("cookiePolicy.contactDescription")}</p>
                            <ul className="list-disc pl-6 text-zinc-300 mt-4">
                                <li>
                                    {t("cookiePolicy.email")}:{" "}
                                    <a
                                        href="mailto:support@bidcoin.live"
                                        className="text-amber-500 hover:text-amber-400 transition-colors"
                                    >
                                        support@bidcoin.live
                                    </a>
                                </li>
                                <li>
                                    {t("cookiePolicy.website")}:{" "}
                                    <Link
                                        to="/"
                                        className="text-amber-500 hover:text-amber-400 transition-colors"
                                    >
                                        bidcoin.live
                                    </Link>
                                </li>
                            </ul>
                        </section>
                    </div>
                </main>
            </div>
        </>
    );
};

export default CookiePolicy;
